/* eslint-disable jsx-a11y/anchor-is-valid */
import { Callout, Intent } from "@blueprintjs/core"
import { MouseEvent, useState } from "react"
import { DIALOG_SIZE, ID } from "src/libs/interfaces/layouts"
import { ScalableDialog } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import makeupIcon from "../../assets/img/makeup.png"
import FieldChanger from "../../views/landing/landing-edit/FieldChanger"
import { isShowByGrands, isShowByParent } from "./LandingCompositeDefault"
import PresetLibraryList from "./PresetLibraryList"

export interface ICompositeFormProps {
    schemaType: any
    origin: any
    value: any
    schemaData: any
    onChange: (value: any, field: string, data: any) => void
    onCollapsesOpen: (i: number) => void
    isCollapsesOpen: boolean[]
    sectionId?:ID
    notClear?: boolean
    formClassname?: string
}

export const CompositeForm = ({ schemaType, value, onChange, onCollapsesOpen, isCollapsesOpen, schemaData, ...props }: ICompositeFormProps): JSX.Element => { 
    const [ cur, setCur ]           = useState<string>( "main" )
    const [isLibOpen, setIsLibOpen] = useState<boolean>( false )
    
    const onClick = (evt: MouseEvent) => {
        const link = evt.currentTarget.getAttribute("aria-current")!
        setCur( link )
        evt.stopPropagation()
        evt.preventDefault()
    } 
    const curTab = schemaData.tabs?.find((tab: any) => tab._id === cur) || {}
    
    return <div className="container pt-0 w_300 pr-0">
        <ul className="nav nav-tabs mb-2">
            {
                Array.isArray( schemaData.tabs ) && 
                schemaData.tabs.length > 1 &&
                schemaData.tabs
                    .filter((tab:any) => {
                        return !!tab.required
                            ?
                            isShowByGrands(schemaData.tabs, tab._id, value, true )
                            :
                            true
                    })
                    .map(( tab: any, i: number ) => { 
                        return <li className="nav-item px-0 user-select-none" key={tab._id}>
                            <a className={ `nav-link smaller text-uppercase letter-spacing-1 px-0 ${ tab._id === cur ? "active" : "" }` } aria-current={ tab._id } href="#" onClick={ onClick }>
                                { 
                                    tab._id === "main" 
                                        ? 
                                        <span className="title text-plain bg-success px-3 py-2">{__( schemaData.name)}</span> 
                                        : 
                                        <span className="px-3 py-2">{__( tab.title )}</span> 
                                }
                            </a>
                        </li>
                    })
            } 
            <div className="ml-auto" />
                {
                    !!schemaData.libName &&
                    <>
                        <div  className="small my-auto hover pointer text-black d-flex bg-warning flex-centered px-2 py-1" onClick={ () => setIsLibOpen( true ) }>
                            <img
                                src={ makeupIcon }
                                height={ 12 }
                                className=" panel-icon landing-icon mr-2 "
                                style={{
                                    height: 12,
                                    width: 12, 
                                    opacity: 1,
                                }}
                                alt=""
                            /> 
                            <span>{ __( "Library" ) }</span>
                        </div>
                        <ScalableDialog
                            dialogSize={ DIALOG_SIZE.MINIMAL }
                            isOpen={ isLibOpen }
                            onClose={ () => setIsLibOpen( false ) }
                        >
                            <div>
                                <div className="title mb-2 p-2">{__("Library")}</div>
                                <PresetLibraryList libName={ schemaData.libName } className=" " />
                            </div>
                            
                        </ScalableDialog>
                    </>
                }
            <div className="px-2" />
        </ul>
        {
            curTab.description &&
            <Callout intent={Intent.SUCCESS} className="py-4 pr-4 pl-5">
                {  __( curTab.description ) }
            </Callout>
        }
        {
            Object.keys(schemaType)
                .filter( key => schemaType[key]?.tab === cur)
                .filter( key => { 
                    /* Скрыть, если хотя бы один из стека require=false */
                    return isShowByGrands(schemaType, key, value)
                })
                .filter((af: string) => !schemaType[af].parent)
                .map(key => { 
                    return <div className={`row data-list ${ props.formClassname ? props.formClassname : "w-auto"}`} key={ key }> 
                        <div className="container pr-5">
                            <FieldChanger 
                                value={ value ? value[ key ] : undefined }
                                { ...schemaType[ key ] } 
                                field={ key }
                                dataName={ key }
                                origin={ value }
                                onChange={ onChange }
                                sectionId={props.sectionId}
                                notClear={props.notClear}
                            />
                        </div>
                    </div>
                })
        }
    </div>
}

/*
 *
*/
export const CompositeFormPrev = ({schemaType, value, onChange, onCollapsesOpen, isCollapsesOpen, schemaData, ...props}: ICompositeFormProps): JSX.Element => { 
    const onSubmenu = () => {

    }
    // console.log( value )
    return <div className="container pt-0 w_300 pr-0">
        {
            Object.keys(schemaType)
                .filter( key => schemaType[key]?.tab === "main")
                .filter( key => {
                    //TODO: config required.  Всё не так. Origin = value
                    let bool = true
                    if( Array.isArray( schemaType[key].required ) ) {
                        const parentField  = schemaType[key].required[0]
                        const parentValues: any[] = schemaType[key].required.slice(1)
                        return !!parentValues?.filter((pv:any) => {
                            const is1 = value[ parentField ] // props.origin ? props.origin[parentField] : {} // текущее зависящее значение
                            const is2 = schemaType[parentField]?.default
                            
                            let boo = typeof ( is1 || is2 ) === "boolean"
                                ? 
                                !!( is1 || is2 ) === !!pv
                                :
                                ( is1 || is2 )   === pv 
                            let boo2 = isShowByParent( parentValues, schemaType, parentField, value ) 
                            
                            // console.log(schemaType[key].title, parentField, ( is1 || is2 ), pv, typeof ( is1 || is2 ), boo, boo2 )
                            
                            return boo || boo2
                        }).length
                    }
                    return bool
                })
                .filter((af: string) => !schemaType[af].parent)
                .map(key => { 
                    return <div className="row data-list w-auto" key={ key }> 
                        <div className="container pr-5">
                            <FieldChanger 
                                value={ value ? value[ key ] : undefined }
                                { ...schemaType[ key ] } 
                                field={ key }
                                dataName={ key }
                                origin={ value }
                                onChange={ onChange }
                                notClear={props.notClear}
                            />
                        </div>
                    </div>
                })
        }
        <div className="d-flex my-2">
        {
            Array.isArray( schemaData.tabs ) && schemaData.tabs
                .filter((tab: any) => tab._id !== "main")
                .map(( tab: any, i: number ) => { 
                    return  <CompositeSingle  
                        key={tab._id}
                        tab={tab} 
                        i={i}   
                        schemaType={schemaType} 
                        origin={origin} 
                        value={value} 
                        onChange={onChange} 
                        onSubmenu={onSubmenu} 
                        onCollapsesOpen={onCollapsesOpen}
                        notClear={props.notClear}
                    />
                })
        }
        </div> 
    </div>
}

const CompositeSingle = ( { tab, i, schemaType, origin, value, onChange, onSubmenu, onCollapsesOpen }: any ) => {
    const [isOpen, setIsOpen] = useState<boolean>( false )
    const onOpen = ( i: number ) => {
        setIsOpen( true )
        onCollapsesOpen( i )
    }
    const onClose = () => {
        setIsOpen( false )
    }
    return <div className="">
        <div className="px-2 btn btn-link w-100" onClick={ () => onOpen( i ) }>
            <div className="smaller letter-spacing-1 text-uppercase">
                { __( tab.title ) }
            </div>
        </div>
        <ScalableDialog
            isOpen={isOpen}
            onClose={onClose}
            dialogSize={DIALOG_SIZE.COMPACT}
            title={ __( tab.title ) }
        >
            <CompositeDialog schemaType={schemaType} origin={origin} tab={tab} value={value} onChange={onChange} onSubmenu={onSubmenu} />
        </ScalableDialog>
    </div>
}

const CompositeDialog = ({ schemaType, origin, tab, value, onChange, onSubmenu}: any): JSX.Element => {
    return <div className="max-height overflow-y-auto" >
        {
            !!tab.description && <Callout intent={Intent.SUCCESS} className="py-4 pl-5 pr-4 smaller letter-spacing-1">
                {__(tab.description)}
            </Callout>
        }
        {
            Object.keys(schemaType)
                .filter( key => schemaType[key]?.tab === tab._id )
                .filter( key => {
                    // config required
                    let bool = true
                    if( Array.isArray( schemaType[key]?.required ) ) {
                        const parentField  = schemaType[key].required[0]
                        const parentValues: any[] = schemaType[key].required.slice(1)
                        return !!parentValues?.filter((_key:any) => { 
                            const is1 = origin ? origin[parentField] : undefined
                            const is2 = schemaType[parentField]?.default
                            //let boo = ( is1 || is2 ) === _key 
                            let boo = typeof ( is1 || is2 ) === "boolean"
                                ? 
                                !!( is1 || is2 ) === !!_key
                                :
                                ( is1 || is2 )   === _key 
                            let boo2 = isShowByParent(  parentValues, schemaType, parentField, origin  )
                            // console.log(schemaType[key].title, "... ", parentField, "; ",  is1 , is2 , ":: ", _key, typeof ( is1 || is2 ), boo, boo2 )                            
                            return boo || boo2
                        }).length
                    }
                    return bool
                })
                .map(key => {
                    // return <div key={key} className="mb-4">{ JSON.stringify( schemaType[key]?.tab ) }</div>
                    return <div className="pl-3 strob01" key={ key }>
                        <FieldChanger 
                            value={ value ? value[ key ]: undefined }
                            { ...schemaType[ key ] } 
                            origin={ value }
                            field={ key }
                            onChange={ onChange }
                            notClear
                            subMenus={[]}
                            onSubMenu={onSubmenu}
                        />
                    </div> 
                })
        }
        </div> 
}